import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import './assets/main.scss';
import routes from "./routes";
import VueRouter from "vue-router";
import InfiniteLoading from 'vue-infinite-loading';
import Vuex from 'vuex'
import VueFilter from 'vue-filter';
import './registerServiceWorker';
Vue.use(VueFilter);
Vue.use(Vuex)
Vue.use(InfiniteLoading);
var VueResource = require('vue-resource');
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);



Vue.config.silent = true;
Vue.config.ignoredElements = ['continutdigital'];
const router = new VueRouter({ mode: "history", routes });
var VueTruncate = require("vue-truncate-filter");
Vue.use(VueTruncate);

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");

//Working
